import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

type Props = {
    title: string;
};

const StyHumanResourcesHeader = styled(Box, {
    name: 'StyHumanResourcesHeader',
})({
    position: 'sticky',
    top: 0,
    zIndex: 2,
    padding: '0 1.5rem',
    background: '#ffffff',
    boxShadow: '4px 8px 24px rgba(0, 0, 0, 0.06)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '78px',
    minHeight: '78px',
    gap: '0.5em',
});

function HumanResourcesHeader({ title }: Props): React.ReactElement {
    return (
        <StyHumanResourcesHeader>
            <Typography
                sx={{ fontSize: '20px', fontWeight: 600 }}
                color="primary"
            >
                {title}
            </Typography>
        </StyHumanResourcesHeader>
    );
}

export default HumanResourcesHeader;
